import { Component } from '@angular/core';
import { PageHeroComponent } from "../../../../shared/components/page-hero/page-hero.component";

@Component({
  selector: 'app-services-hero-section',
  imports: [PageHeroComponent],
  templateUrl: './services-hero-section.component.html',
  styleUrl: './services-hero-section.component.css',
})
export class ServicesHeroSectionComponent {

}
